/**
 * unmatched.js — Gmail unmatched email helpers, now via BigQuery backend.
 */

import { dismissUnmatchedEmail, deleteUnmatchedEmail } from './backend.js';

export async function dismissUnmatched(getToken, email) {
  await dismissUnmatchedEmail(getToken, email);
}

export async function removeUnmatched(getToken, email) {
  await deleteUnmatchedEmail(getToken, email);
}
